module.exports = __webpack_public_path__ + "images/thumb-a66a3c4a81af346ec1c2a584e8ef34e7.jpg";